import { useRef, useState, useCallback } from 'react';

import { useAppSelector } from '@/redux/hooks';
import { getInitialWidth } from '@/redux/modules/windowSize';

import useWindowUpdateHelper from './useWindowUpdateHelper';

const useIsWiderThan = (width: number, initialSSRWidth?: number): boolean => {
    const initialWidth = useAppSelector(getInitialWidth);
    const effectiveInitialWidth = initialSSRWidth ?? initialWidth ?? 768;

    const isWiderRef = useRef(effectiveInitialWidth > width);
    const [isWiderThan, setIsWiderThan] = useState(effectiveInitialWidth > width);

    const handleWidthResize = useCallback(() => {
        const isWider = window.innerWidth > width;
        const isWiderHasChanged = isWiderRef.current !== isWider;
        if (isWiderHasChanged) {
            isWiderRef.current = isWider;
            setIsWiderThan(isWider);
        }
    }, [width]);

    useWindowUpdateHelper(handleWidthResize);

    return isWiderThan;
};

export default useIsWiderThan;
